import React from "react";

export default function PopupRowsDeac() {
    
  return (
<div id = 'helper1'>
<div className = 'alertContainer'>
    <div id="popUpOverlay">
      <div id="popUpBox">
      <p className = 'popUpText'>
        User account has been deactivated.
      </p>
      <button className = 'alert_button' onClick={()=>removeComp()}
      > 
      OK
      </button>
      </div>
    </div>
    </div>
    </div>
  );
  
}
function removeComp(){
    document.getElementById('helper1').style.display = 'none';
}